import React from 'react';

import withPageComponents from '../../../page/components/with-page-components';
import PDPUpSell from '../../components/pdp-upsell';

const getUpSellPopupProduct = (product, upsell) => {
    const { productsList = [], ...rest } = upsell || {};
    const upsellPrd = {
        ...product,
        upsell: {
            ...rest,
            productsList: productsList.slice(0, 4)
        },
        asyncDataLoaded: true
    }
    return upsellPrd;
}


const oosPopup = ({ product, pdpUpsell }) => {
    const { productsList } = pdpUpsell || {};
    if (productsList && productsList.length > 0 && product) {
        return <PDPUpSell
            product={getUpSellPopupProduct(product, pdpUpsell)}
            modalOnly={true} />
    }
    return null;
}

export default withPageComponents(oosPopup, { components: ['product', 'pdpUpsell'] })
